const DEFAULT_OPTIONS = {
  // can be 'error', 'success' or 'blank'
  appearance: 'error',
};

export { DEFAULT_OPTIONS };
